import { useLocale } from "@/i18n/detect";
import { SoftRule } from "@/components/landing/SoftRule";

const companies = [
  "Data Center Solutions",
  "Image Staffing",
  "Black Diamond Financial",
  "Ad-Walls",
  "Tempus Hair Restoration",
  "Veritech",
];

const Logos = () => {
  const { ui } = useLocale();
  return (
    <section className="relative bg-card/50 py-12">
      <SoftRule />
      <SoftRule side="bottom" />
      <div className="container">
        <p className="text-center text-sm font-medium uppercase tracking-widest text-muted-foreground">
          {ui.logos.trustedBy}
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
          {companies.map((c) => (
            <span key={c} className="font-display text-2xl font-bold text-muted-foreground/70 transition-colors hover:text-secondary">
              {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Logos;
